import React from 'react';
export function AcquisitionCostsSection() {
  return <section data-id="element-3207">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-3208">
        <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-3209">
          1. Acquisition Costs
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0 space-y-6 text-gray-700 text-lg leading-relaxed" data-id="element-3210">
        <p data-id="element-3211">
          In general, these costs relate to obtaining and setting up the
          machine:
        </p>
        <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-3212">
          <li data-id="element-3213">Purchase price</li>
          <li data-id="element-3214">Installation and setup</li>
          <li data-id="element-3215">Employee training</li>
        </ul>
        <p className="bg-gray-50 p-6 rounded-lg border border-gray-100" data-id="element-3216">
          The authors add that post-sale service, supplier reputation, equipment
          warranty and support services are also important at different times in
          the machine's life cycle. For example, they write,{' '}
          <span className="italic" data-id="element-3217">
            "A vendor's availability to conduct operations and maintenance
            training and improve employee competency is something that can
            prevent productivity drag."
          </span>
        </p>
      </div>
    </section>;
}